// extracted by mini-css-extract-plugin
module.exports = {"root":"SetupLayout_root__2ISe2","header":"SetupLayout_header__2uPdB","body":"SetupLayout_body__3aZKz"};